"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRegex = void 0;
var RegExpRule = /(\/?)(.+)\1([a-z]*)/;
var FlagRule = /^(?!.*?(.).*?\1)[AJUXgimsux]+$/;
var parseRegex = function (subject) {
    var match = RegExpRule.exec(subject);
    if (!match) {
        throw new Error('Invalid RegExp.');
    }
    if (match[3] && !FlagRule.test(match[3])) {
        return new RegExp(subject);
    }
    return new RegExp(match[2], match[3]);
};
exports.parseRegex = parseRegex;
